export function maskPhone(phone: string): string {
  if (!phone) {
    return ''
  }

  return `${phone.slice(0, 5)}****${phone.slice(-2)}`
}
